// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2689":"c39c03672e9bbd0c","3378":"de0dd5e4bb6e9269","9095":"878f85b29daab4f1","9750":"85a29fc92ab0ec3c"}[chunkId] + ".js";
};